var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSapiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53,30.6c-1.7-4.1-6.4-6-10.5-4.3L33,30c-0.8,0.3-1.8,0-2.2-0.7c-0.6-1-0.1-2.1,0.8-2.5l13.7-5.5 c3.2-1.3,4.8-5,3.5-8.3l0,0L19.1,25c-0.3,0.1-0.4,0.3-0.6,0.6c-0.1,0.3-0.1,0.6,0,0.7c0.1,0.6,0.8,0.8,1.4,0.6l7.3-2.9 c0.6-0.1,1.1,0,1.4,0.4c0.1,0.3,0.1,0.6,0,0.8c-0.1,0.3-0.3,0.4-0.6,0.6l-5.9,2.5c-0.3,0.1-0.4,0.3-0.6,0.6 c-0.1,0.3-0.1,0.6,0,0.7c0.1,0.6,0.8,0.8,1.4,0.6l1.3-0.6l0,0c0.8-0.3,1.8,0.1,2.2,1c0.1,0.4,0.1,1,0,1.4c-0.1,0.4-0.4,0.7-0.8,1 l-14.7,6c-0.3,0.1-0.4,0.3-0.6,0.6c-0.1,0.3-0.1,0.6,0,0.7c0.1,0.6,0.8,0.8,1.4,0.6L28.6,34c0.6-0.1,1.1,0,1.4,0.4 c0.1,0.3,0.1,0.6,0,0.8c-0.1,0.3-0.3,0.4-0.6,0.6l0,0l-9,3.6c-0.3,0.1-0.4,0.3-0.6,0.6c-0.1,0.3-0.1,0.6,0,0.8 c0.3,0.6,0.8,0.8,1.4,0.6l23.5-9.5c1-0.4,2.1,0.1,2.4,1.3c0.3,0.8-0.3,1.8-1.1,2.1l-19.7,8.1c-0.3,0.1-0.4,0.3-0.6,0.6 c-0.1,0.3-0.1,0.6,0,0.8c0.3,0.6,0.8,0.7,1.4,0.4L30,44c0.6-0.1,1.1,0,1.4,0.6c0.1,0.3,0.1,0.6,0,0.8c-0.1,0.3-0.3,0.4-0.6,0.6 l-7.3,2.9c-0.3,0.1-0.4,0.3-0.6,0.6c-0.1,0.3-0.1,0.6,0,0.8c0.3,0.6,0.8,0.7,1.4,0.4l23.9-9.7C52.7,39.6,54.8,34.8,53,30.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,45.9c0.1-0.3,0.1-0.6,0-0.7c-0.1-0.6-0.8-0.8-1.4-0.6L19.7,46c-0.3,0.1-0.4,0.3-0.6,0.6 c-0.1,0.3-0.1,0.6,0,0.8c0.3,0.6,0.8,0.7,1.4,0.4l3.9-1.5C24.7,46.3,25,46.1,25,45.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.2,33.7l5.3-2.1c0.3-0.1,0.4-0.3,0.6-0.6c0.1-0.3,0.1-0.6,0-0.7c-0.1-0.6-0.8-0.8-1.4-0.6l-5.3,2.1 c-0.3,0.1-0.4,0.3-0.6,0.6c-0.1,0.3-0.1,0.6,0,0.7C13,33.7,13.7,34,14.2,33.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSapiIcon);
export default __webpack_public_path__ + "static/media/sapi-icon.0c81707283b92531d89055d53b225a3c.svg";
export { ForwardRef as ReactComponent };